import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import { Box, Button, Heading } from '@chakra-ui/react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ViewCategories = () => {
  const [categories, setCategories] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(response.data.$values);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/categories/${id}`);
        setCategories(categories.filter((cat) => cat.categoryId !== id));
      } catch (error) {
        console.error('Error deleting category:', error);
      }
    }
  };

  const columnDefs = [
    { headerName: 'Category ID', field: 'categoryId' },
    { headerName: 'Category Name', field: 'categoryName' },
    {
      headerName: 'Actions',
      field: 'categoryId',
      cellRendererFramework: (params) => (
        <>
          <Button colorScheme="blue" onClick={() => handleEdit(params.data)}>Edit</Button>
          <Button colorScheme="red" ml={3} onClick={() => handleDelete(params.value)}>Delete</Button>
        </>
      ),
    },
  ];

  const handleEdit = (category) => {
    // Logic for editing category
  };

  return (
    <Box p={8}>
      <Heading mb={6}>View Categories</Heading>
      <div className="ag-theme-alpine" style={{ height: '500px', width: '600px' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={categories}
          onGridReady={(params) => setGridApi(params.api)}
        />
      </div>
    </Box>
  );
};

export default ViewCategories;
